import { render, staticRenderFns } from "./consumablesImportTemplate.vue?vue&type=template&id=064d20b0&scoped=true&"
import script from "./consumablesImportTemplate.vue?vue&type=script&lang=js&"
export * from "./consumablesImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./consumablesImportTemplate.vue?vue&type=style&index=0&id=064d20b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d20b0",
  null
  
)

export default component.exports